import { Link } from "react-router-dom";
import { Shirt, Flame, Wind, Gem, Sparkles } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const cats = [
  { label: "Hoodies", icon: Wind, to: "/shop?cat=Hoodies", color: "text-accent" },
  { label: "T-Shirts", icon: Shirt, to: "/shop?cat=T-Shirts", color: "text-primary" },
  { label: "Pants", icon: Flame, to: "/shop?cat=Pants", color: "text-glow-red" },
  { label: "Jackets", icon: Gem, to: "/shop?cat=Jackets", color: "text-accent" },
  { label: "Accessories", icon: Sparkles, to: "/shop?cat=Accessories", color: "text-primary" },
];

const CategoryCards = () => (
  <section className="py-8">
    <div className="container mx-auto px-4">
      <ScrollReveal direction="up">
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {cats.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="flex shrink-0 flex-col items-center gap-2 rounded-lg border border-border/50 bg-card px-6 py-4 transition-all hover:border-primary/40 hover-glow min-w-[120px]"
            >
              <c.icon className={`h-8 w-8 ${c.color}`} />
              <span className="text-xs font-bold uppercase tracking-wider">{c.label}</span>
            </Link>
          ))}
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default CategoryCards;
